import styled from 'styled-components'

const LI = styled.li`
  margin: 0;
  padding: 0;
  list-style: none;
`

export default LI
